
import PropTypes from 'prop-types';

import isEqual from 'lodash/isEqual';
import { useCallback, useEffect, useState, } from 'react';

import axios from 'axios';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';

import {
    useTable,
    emptyRows,
    TableNoData,
    getComparator,
    TableEmptyRows,
    TableHeadCustom,
    TableSelectedAction,
    TablePaginationCustom,
    TableSkeleton,
} from '../components/table';
import Scrollbar from '../components/scrollbar';
import ReferralDetailsTableRow from './ReferralDetails-table-row';
// import CompanyInfoDocTableRow from '../company-info-doc-table';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: 'REFERRED TO', label: 'REFERRED TO', width: 280, color: '#1D53E7', fontWeight: 600 },
    { id: 'Date ', label: 'Date', width: 80, color: '#1D53E7', fontWeight: 600 },
    { id: 'CASHBACK DATE', label: 'CASHBACK DATE', width: 80, color: '#1D53E7', fontWeight: 600 },

    { id: 'TRANSACTION ID', label: 'TRANSACTION ID', width: 180, color: '#1D53E7', fontWeight: 600 },
    { id: 'AMOUNT', label: 'AMOUNT', width: 80, color: '#1D53E7', fontWeight: 600 },
    // { id: '', width: 88 },
];

const defaultFilters = {
    name: '',
    role: [],
    status: 'all',
};

// ----------------------------------------------------------------------

export default function ReferralDetailsTable({onUpdateRefEarning}) {
    const SERVER_URI = process.env.REACT_APP_SERVER_URI;
    const Referral = `${SERVER_URI}/successfulReferral`;
    const table = useTable();



    const [tableData, setTableData] = useState([]);
    // const [tableData, setTableData] = useState(dummyData);

    const [filters,] = useState(defaultFilters);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);


    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);


    const token = localStorage.getItem("accessToken");
    const fetchReferralData = useCallback(async () => {
        setLoading(true);
        let config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        try {
            const response = await axios.get(
                // `${Referral}`,
                `${Referral}?page=${page}&limit=${rowsPerPage}`,
                config,
                {
                    withCredentials: true,
                }
            );
            setErrorMessage('');
            setTableData(response?.data?.referral);
            setTotalRecords(response?.data?.pagination?.totalItems);
            onUpdateRefEarning(response?.data?.earning)
        } catch (error) {
            console.log(error);
            if (!navigator.onLine) {
                setErrorMessage('You are currently offline. Please check your network connection.');
            } else if (error) {
                setErrorMessage(error.message || 'An error occurred while processing your request.');
                // enqueueSnackbar(error.message, { variant: 'error' });
            } else {
                setErrorMessage('An unexpected error occurred.');
            }
        } finally {
            setLoading(false); // Hide loader
        }
    }, [ page, rowsPerPage, token,onUpdateRefEarning]);




    useEffect(() => {
        fetchReferralData(); // Fetch the first page of data initially
        // eslint-disable-next-line
    }, [page, rowsPerPage]);

    const dataFiltered = applyFilter({
        inputData: tableData,
        comparator: getComparator(table.order, table.orderBy),
        filters,
    });

    // const dataInPage = dataFiltered.slice(
    //     (page - 1) * rowsPerPage,
    //     (page - 1) * rowsPerPage + rowsPerPage
    // );



    // const denseHeight = table.dense ? 56 : 56 + 20;
    const denseHeight = table.dense ? 36 : 56;


    const canReset = !isEqual(defaultFilters, filters);

    const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;





    return (
        <>
            {loading && (
               <TableSkeleton />
            )}
                <Card sx={{ borderRadius: 5 }}>


                    <TableContainer sx={{ position: 'relative', overflow: 'unset', }}>
                        <TableSelectedAction
                            dense={table.dense}
                            numSelected={table.selected.length}
                            rowCount={dataFiltered.length}
                            onSelectAllRows={(checked) =>
                                table.onSelectAllRows(
                                    checked,
                                    dataFiltered.map((row) => row.id)
                                )
                            }

                        />

                        <Scrollbar  sx={{ maxHeight: '65vh', overflowY: { xs: 'auto', md: 'unset' } }}  >
                            <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 460 }}>
                                <TableHeadCustom

                                    order={table.order}
                                    orderBy={table.orderBy}
                                    headLabel={TABLE_HEAD}
                                    rowCount={dataFiltered.length}
                                    numSelected={table.selected.length}
                                    onSort={table.onSort}
                                    onSelectAllRows={(checked) =>
                                        table.onSelectAllRows(
                                            checked,
                                            dataFiltered.map((row) => row.id)
                                        )
                                    }
                                />

                                <TableBody>
                                    {dataFiltered
                                        .slice(
                                            table.page * table.rowsPerPage,
                                            // table.page * table.rowsPerPage + table.rowsPerPage
                                        ).map((row) => (
                                            <ReferralDetailsTableRow
                                                key={row.id}
                                                row={row} />
                                        ))}
                                    <TableEmptyRows
                                        height={denseHeight}
                                        emptyRows={emptyRows(table.page, table.rowsPerPage, dataFiltered.length)}
                                    />

                                    <TableNoData notFound={notFound} />
                                </TableBody>
                            </Table>
                        </Scrollbar>
                    </TableContainer>

                    <TablePaginationCustom
                        count={totalRecords}
                        page={page - 1}
                        rowsPerPage={rowsPerPage}
                        onPageChange={(e, newPage) => setPage(newPage + 1)}
                        onRowsPerPageChange={(e) => {
                            const newRowsPerPage = parseInt(e.target.value, 10);
                            setRowsPerPage(newRowsPerPage);
                            setPage(1);
                        }}
                        dense={table.dense}
                        onChangeDense={table.onChangeDense}
                    />
                  
                </Card>

        </>
    );
}

// ----------------------------------------------------------------------

function applyFilter({ inputData, comparator, filters }) {
    const { name, status, role } = filters;

    const stabilizedThis = inputData.map((el, index) => [el, index]);

    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });

    inputData = stabilizedThis.map((el) => el[0]);

    if (name) {
        inputData = inputData.filter(
            (user) => user.name.toLowerCase().indexOf(name.toLowerCase()) !== -1
        );
    }

    if (status !== 'all') {
        inputData = inputData.filter((user) => user.status === status);
    }

    if (role.length) {
        inputData = inputData.filter((user) => role.includes(user.role));
    }

    return inputData;
}
ReferralDetailsTable.propTypes = {
    companyId: PropTypes.string,
};
